export const DEFAULT_PAGE_SIZE_OPTIONS = [50, 80, 100, 150, 200, 300] as const;
export const DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE_OPTIONS[0];
